import React from 'react';
import styles from './Ellipse.scss';

const Ellipse = () => {
  return <div className={styles.ellipse} />;
};
export default Ellipse;
